// Ambiente de desenvolvimento
const isDevelopment = process.env.NODE_ENV === 'development';

// URLs da API
const API_URL = isDevelopment 
  ? 'http://localhost:5000'   // URL local para desenvolvimento
  : 'https://api.silentpuma.com'; // URL de produção

export { API_URL }; 